import clsx from 'clsx'

import { BaseResults } from 'libs/searchspring/components/recommendations/BaseResults'

export function GridResults({
  className,
  wrapperClassName = '',
  productCardSettings,
  limit,
  useCssGrid = false
}) {
  const containerClassName = useCssGrid
    ? 'grid grid-cols-2 md:grid-cols-4 items-stretch w-full h-fit'
    : 'flex relative'
  const itemClassName = useCssGrid ? clsx(className, 'size-full') : className
  const mergedWrapperClassName = useCssGrid
    ? wrapperClassName
    : `${wrapperClassName} gap-grid flex-wrap`.trim()

  return (
    <BaseResults
      className={itemClassName}
      containerClassName={containerClassName}
      wrapperClassName={mergedWrapperClassName}
      productCardSettings={productCardSettings}
      placeholderCount={limit}
    />
  )
}
